import { assert_false } from '@shared/asserts/utils_asserts';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__base } from '../../../_fields/_base/FIELD__base';
import { ENUM__invocation_role as ENUM } from '../../../_invocations/_base/ENUM__invocation_role';
import { INVOCATION_LATENTS__create_noise } from '../../../_invocations/latents/INVOCATION_LATENTS__create_noise';
import { INVOCATION_SD__denoise_latents_pipeline } from '../../../_invocations/sd/denoise/INVOCATION_SD__denoise_latents_pipeline';
import { ENUM__graph_template_name } from '../ENUM__graph_template_name';

export function GENERATION_TOOL__sd1__select_models(tool: DTO__generation_tool) {
  let { graph } = tool;

  assert_false(graph.is_stub());

  /*
   *
   */

  const node__denoise = INVOCATION_SD__denoise_latents_pipeline.create_node_for(graph, ENUM.CORE__DENOISE);

  const node__noise = INVOCATION_LATENTS__create_noise.create_node_for(graph, ENUM.CORE__LATENTS_NOISE);

  /*
   *
   */

  let fields__visible: FIELD__base[] = [node__denoise.unet.model, node__noise.seed];
  let field_column_id = node__denoise.unet.model.meta.field_id;
  let field_row_id = node__noise.seed.meta.field_id;

  tool.view__add({
    name: ENUM__graph_template_name.SELECT_MODELS,
    group: '3. Models',

    //
    fields__visible,
    fields__stored: fields__visible,
    //
    field_column_id,
    field_row_id,
    //
    field_id_info__ml_asset: node__denoise.unet.model.meta.field_id,
  });
}
